import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const uploadFileForGenericAccountDataUploadTypes = getApiActionTypes(
  'DATA_COLLECTION/UPLOAD_FILE_FOR_UPLOAD_GENERIC_ACCOUNT_DATA',
);
export const CLEAR_ACCOUNT_DATA_UPLOAD_RESULT = 'DATA_COLLECTION/CLEAR_ACCOUNT_DATA_UPLOAD_RESULT';
